// 共通数量を、選択した商品のAPI最小数量・刻み幅・上限に照らして検証する
export function productQuantityError(value, limits = {}) {
  const minimum = limits.minimum || 1;
  const multiple = limits.multiple_of || 1;
  if (!Number.isInteger(value) || value < 1) return '数量は1以上の整数で入力してください。';
  if (value < minimum || value % multiple !== 0) return minimum + '以上、' + multiple + '刻みで入力してください。';
  if (limits.maximum > 0 && value > limits.maximum) return '数量は' + limits.maximum + '以下で入力してください。';
  return '';
}

// 複数の種別を選んだ場合は、全種別に共通する数量の範囲と刻み幅を使う
export function sharedProductQuantityLimits(limits) {
  function gcd(a, b) { return b ? gcd(b, a % b) : a; }
  const multiple = limits.reduce((step, item) => {
    const next = item.multiple_of || 1;
    return step * next / gcd(step, next);
  }, 1);
  const minimum = Math.ceil(Math.max(1, ...limits.map(item => item.minimum || 1)) / multiple) * multiple;
  const maxima = limits.map(item => item.maximum).filter(value => value > 0);
  const maximum = maxima.length ? Math.floor(Math.min(...maxima) / multiple) * multiple : 0;
  return { minimum, maximum, multiple_of: multiple, valid: !maxima.length || maximum >= minimum };
}

// 標準APIへ順に追加し、成功済みの種別を通知して再送による重複を防ぐ
export async function addProductSelection(selection, add, onAdded) {
  for (const entry of selection) {
    const cart = await add(entry.id, entry.quantity);
    onAdded(entry, cart);
  }
}
